import { api } from './api';

// ─── Types ────────────────────────────────────────────────────────────────────

export interface UserRole {
  rolId: number;
  nombre: string;
}

export interface User {
  usuarioId: number;
  nombre: string;
  email: string;
  rol: UserRole;
  activo: boolean;
}

export interface CreateUserPayload {
  nombre: string;
  email: string;
  rolId: number;
}

export interface UpdateUserPayload {
  nombre?: string;
  email?: string;
  rolId?: number;
  activo?: boolean;
}

// ─── Service ──────────────────────────────────────────────────────────────────

const ENDPOINT = '/admin/users';

export const usersService = {
  getAll: (email?: string) => {
    const params = email ? { email } : undefined;
    return api.get<User[]>(ENDPOINT, { params });
  },

  getById: (id: number) =>
    api.get<User>(`${ENDPOINT}/${id}`),

  insert: (payload: CreateUserPayload) =>
    api.post<User>(ENDPOINT, payload),

  update: (id: number, payload: UpdateUserPayload) =>
    api.put<User>(`${ENDPOINT}/${id}`, payload),

  deleteById: (id: number) =>
    api.delete(`${ENDPOINT}/${id}`),
};
